import * as React from 'react';
import QRCode from './QRCode';

export interface ITimerCodeProps {
  timerCode?: number
}

export function TimerCode(props: ITimerCodeProps) {
  if (!props.timerCode) {
    return null;
  }
  return (
    <>
      <QRCode myTimerCode={props.timerCode} />
    </>
  );
}



// WEBPACK FOOTER //
// ./src/Timer/TimerCode.tsx